import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { REFLECTION_FEATURE_KEY } from './keys';
import { reflectionReducer } from './reducers/reflection.reducer';
import { ReflectionEffects } from './effects/reflection.effects';
import { Reflection_ProgressBridge } from './bridge';

export const reflectionStoreProviders = [provideState(REFLECTION_FEATURE_KEY, reflectionReducer), provideEffects(ReflectionEffects, Reflection_ProgressBridge)];

export { ReflectionFacade } from './facades/reflection.facade';
export { Reflection } from './models';
export type { ReflectionValue } from './models';
export { reflectionActions } from './actions/reflection.actions';
